import React from 'react';
import '../../assets/css/eqsigninpage.css';
import { isNullOrUndefined } from './CommonFunctions';
const SignInSection ={
    "height" :"399px"  
}

class SignInForm extends React.Component {
	constructor(props) {
		super(props);
		this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
		this.pagePath = window.location.href.indexOf("equipmentreturn") > -1 ? "equipmentreturn" : "equipment-return";
		this.authURL = (window.location.href.indexOf('sit') > -1) ? "https://sit-ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&mode=i&fromVZT=Y&clientId=ghlogin&goto=https://sso-np.ebiz.verizon.com/consumer/myverizon/router?Target%3dhttps%253A%252F%252Fwwwawssit.ebiz.verizon.com%252Fsupport%252F"+window.domain_url+"%252F"+ this.pagePath +"&userNameOnly=false" :
		"https://ssoauth.verizon.com/vzauth/UI/Login?realm=vzw&service=WlnOneVerizonChain&mode=i&fromVZT=Y&clientId=atlassigninpage&userNameOnly=false&goto=https%3A%2F%2Fwww.verizon.com%2Fconsumer%2Fmyverizon%2Frouter%3FTarget%3Dhttps%25253A%25252F%25252Fwww.verizon.com%25252Fsupport%25252F"+ window.domain_url +"%25252F"+ this.pagePath;
		
	}


	toggleTab(e) {
		let tabItem = e.target;
        if(tabItem.classList.contains('tabs_tab') && !tabItem.classList.contains('active')) {
            // Hiding previous content
            let previouslySelectedItem = tabItem.parentElement.querySelector('.active');
            let previouslySelectedContent = document.querySelector('.tab-content.active');
            previouslySelectedItem.classList.remove('active');
            previouslySelectedItem.setAttribute('aria-hidden', true);
            previouslySelectedItem.setAttribute('aria-selected', false);
            previouslySelectedContent.classList.remove('active');
            previouslySelectedContent.setAttribute('aria-hidden', true);
            previouslySelectedContent.setAttribute('aria-selected', false);

            // Display Selected Item
            let currentlySelectedItem = tabItem;
            let currentlySelectedItemIndex = parseInt(tabItem.getAttribute('data-item-index'), 10);
            let currentlySelectedContent = document.querySelectorAll('.tab-content')[currentlySelectedItemIndex];
            currentlySelectedItem.classList.add('active');
            currentlySelectedContent.classList.add('active');
            currentlySelectedItem.setAttribute('aria-hidden', false);
            currentlySelectedItem.setAttribute('aria-selected', true);
            currentlySelectedContent.setAttribute('aria-selected', true)
            currentlySelectedContent.setAttribute('aria-hidden', false)
        }
    }

	onKeyValidationNonEQSignin(e){		
		// if(e.shiftKey && e.keyCode == 9 || e.keyCode == undefined && e.shiftKey == undefined){}else{
		// 	this.props.KeyUpValidation(e);
		// }//DOPMO-157298
		this.props.KeyUpValidation(e);
	}

	render() {
		if(!this.isMobile) {
			return (
				!isNullOrUndefined(this.props.Data.eqreturnlist) && (
				<React.Fragment>
					<div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium hide-for-medium-down hide-padding">
						<h2 className="text-large bold margin-bottom-tiny signin_label">
							{this.props.Data.eqreturnlist[0].title}</h2>
						<p>{this.props.Data.eqreturnlist[0].description}</p>
					</div>
					<div className="row m_sigin-tabs-content">
					<div className="row padding-vert-zero margin-bottom-small margin-vert-zero">
						<div className="medium-p-48 columns padding-vert-zero w_signin active">
							<h3 className="signin_type hide-for-medium-down">
								{this.props.Data.eqreturnlist[0].header}</h3>
							<div className="signin_content">
								<form action="/support/consumer/equipment-return" id="monzipform" method="post" name="monzipform" noValidate="">
									<div id="unauthenticated">
										<div id="signordzip">
											<div>
												<label className="label" htmlFor="orderNumber">{this.props.Data.eqreturnlist[0].orderno}</label>
												<input data-cs-mask ref={this.props.MTNRef} onKeyUp={this.onKeyValidationNonEQSignin.bind(this)} onBlur={this.onKeyValidationNonEQSignin.bind(this)}  className="form-required-field mtn" minLength="8" maxLength="13" id="orderNumber" inputMode="alphanum" placeholder="Order Number" required type="text"/>
												<div className="signin-error" id="error-ordernumber" ></div>
												<a className="block margin-pull-up-tiny padding-horiz-micro font-arial blue-font" data-open-modal="orderNumber" data-track={this.props.Data.eqreturnlist[0].text} onClick={this.props.Open} tapindex="0" href="#0" id="aOrderNumber">{this.props.Data.eqreturnlist[0].text}</a>
												
											</div>
											<div>
												<label className="label" htmlFor="zipCode">{this.props.Data.eqreturnlist[0].zipcode}</label>
												<input data-cs-mask ref={this.props.ZipCodeRef} onKeyUp={this.onKeyValidationNonEQSignin.bind(this)} onBlur={this.onKeyValidationNonEQSignin.bind(this)} className="form-required-field zip" maxLength="5" id="zipCode" inputMode="numeric" placeholder="00000" required type="text"/>
												<div className="signin-error" id="error-zipcode"  ></div>
											</div>
										</div>
										<div className="signin-validation signinbtn-error" ref={this.props.ValidationRef}   id="validErr" role="alert" aria-atomic="true" ></div>
										<div id="ordzipsigninbutton" >
											<button className="submit" id="Submit" tabIndex="0"  role="button" type="button" onClick={this.props.SignUpValidaition} data-track={this.props.Data.eqreturnlist[0].signin} >{this.props.Data.eqreturnlist[0].signin}</button></div>
									</div>
								</form>
							</div>
						</div>
						<div className="medium-p-48 columns padding-vert-zero" data-tab="authenticated">
							<h3 className="signin_type hide-for-medium-down" >
								Sign In with My Verizon User ID &amp; Password</h3>
							<div className="signin_content text-center" id="authenticated">
								<iframe frameBorder="0" scrolling="no" src={this.authURL} id="iframeAuthURL" style={SignInSection}></iframe></div>
						</div>
					</div>
				</div>
			</React.Fragment>
			)) 
		} else {
			return(
				<React.Fragment>
				<ul className="w_tabs hide-for-large-up margin-bottom-zero tiny-block-grid-2 signin_tabs">
					<li className="tabs_tab active" data-tab-id="unauthenticated" data-item-index="0" onClick={this.toggleTab.bind(this)}>
						Sign in with Order Number
					</li>
					<li className="tabs_tab" data-tab="authenticated" data-item-index="1" onClick={this.toggleTab.bind(this)}>
						Sign in with your My Verizon User ID
					</li>
				</ul>
				<div className="tab-content active" data-tab-id="unauthenticated">
					<div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium hide-for-medium-down hide-padding er_title">
							<p className="text-large bold margin-bottom-tiny signin_label">
								{this.props.Data.eqreturnlist[0].title}</p>
							<p>{this.props.Data.eqreturnlist[0].description}</p>
					</div>
					<div className="medium-p-48 columns padding-vert-zero w_signin active">
							<div className="signin_type hide-for-medium-down">
								{this.props.Data.eqreturnlist[0].header}</div>
							<div className="signin_content">
								<form action="/support/residential/account/manage-service/equipment-returns" id="monzipform" method="post" name="monzipform" noValidate="">
									<div id="unauthenticated">
										<div id="signordzip">
											<div>
												<label className="label" htmlFor="orderNumber">{this.props.Data.eqreturnlist[0].orderno}</label>
												<input data-cs-mask ref={this.props.MTNRef} onKeyUp={this.onKeyValidationNonEQSignin.bind(this)} onBlur={this.onKeyValidationNonEQSignin.bind(this)}  className="form-required-field mtn" minLength="8" maxLength="13" id="orderNumber" inputMode="alphanum" placeholder="Order Number" required type="text"/>
												<div className="signin-error"></div>
												<a className="block margin-pull-up-tiny padding-horiz-micro font-arial blue-font" data-open-modal="orderNumber" data-track={this.props.Data.eqreturnlist[0].text} onClick={this.props.Open}>{this.props.Data.eqreturnlist[0].text}</a>
												
											</div>
											<div>
												<label className="label" htmlFor="zipCode">{this.props.Data.eqreturnlist[0].zipcode}</label>
												<input data-cs-mask ref={this.props.ZipCodeRef} onKeyUp={this.onKeyValidationNonEQSignin.bind(this)} onBlur={this.onKeyValidationNonEQSignin.bind(this)} className="form-required-field zip" maxLength="5" id="zipCode" inputMode="numeric" placeholder="00000" required type="text"/>
												<div className="signin-error"></div>
											</div>
										</div>
										<div className="signin-validation signinbtn-error" ref={this.props.ValidationRef}  role="navigation" aria-hidden="true"></div>
										<div id="ordzipsigninbutton" tabindex="0">
											<button className="submit" id="Submit" type="button" onClick={this.props.SignUpValidaition} data-track={this.props.Data.eqreturnlist[0].signin} >{this.props.Data.eqreturnlist[0].signin}</button></div>
									</div>
								</form>
							</div>
						</div>
				</div>

				{/* Second tab */}
				<div className="tab-content" data-tab="authenticated">
					<div className="tiny-padding-vert-tiny medium-padding-vert-small padding-top-medium hide-for-medium-down hide-padding er_title">
								<p className="text-large bold margin-bottom-tiny signin_label">
									{this.props.Data.eqreturnlist[0].title}</p>
								<p>{this.props.Data.eqreturnlist[0].description}</p>
					</div>
					<div className="medium-p-48 columns padding-vert-zero">
							<div className="signin_type hide-for-medium-down" >
								Sign In with My Verizon User ID &amp; Password</div>
							<div className="signin_content text-center" id="authenticated">
								<iframe frameBorder="0" scrolling="no" src={this.authURL} id="iframeAUTHURL1"></iframe></div>
					</div>
				</div>
				
				</React.Fragment>
			)
		}
	}
}

export default SignInForm


// WEBPACK FOOTER //
// ./src/components/modules/EqReturnNonSignIn.js